export default __webpack_public_path__ + "static/media/logo-no-text.eb392e50.png";